import { Toast } from 'vant';
import axios from 'axios'
import { get, isEmpty, merge } from 'lodash'
import qs from 'qs'
// @ts-ignore
import cookies from '@/utils/util.cookies.js'

/**
 * @description 记录和显示错误
 * @param {Error} error 错误对象
 */
function handleError(error) {
    // console.log(error)
    if (error.url.includes('tradecore/order/load')) {
        return;
    }
    // 显示提示
    Toast({
        message: error.message
    });
}

/**
 * @description 创建请求实例
 */
function createService() {
    // 创建一个 axios 实例
    const service = axios.create()
    // 请求拦截
    service.interceptors.request.use(
        config => config,
        error => {
            // 发送失败
            console.log(error)
            return Promise.reject(error)
        }
    )
    // 响应拦截
    service.interceptors.response.use(
        response => {
            // console.log(response)
            // 有 code 判断为项目接口请求
            if (response.data.code == 'SUCCESS' || response.data.status == 'SUCCESS') {
                return response.data;
            } else {
                let error = { message: response.data.msg || response.data.data.msg, status: response.data.status, url: response.config.url }
                handleError(error)
                throw error
            }
        },
        error => {
            const status = get(error, 'response.status')
            switch (status) {
                case 400:
                    error.message = '请求错误';
                    break
                case 401:
                    error.message = '未授权，请登录';
                    break
                case 403:
                    error.message = '拒绝访问';
                    break
                case 404:
                    error.message = `请求地址出错: ${error.response.config.url}`;
                    break
                case 408:
                    error.message = '请求超时';
                    break
                case 500:
                    error.message = '服务器内部错误';
                    break
                case 501:
                    error.message = '服务未实现';
                    break
                case 502:
                    error.message = '网关错误';
                    break
                case 503:
                    error.message = '服务不可用';
                    break
                case 504:
                    error.message = '网关超时';
                    break
                case 505:
                    error.message = 'HTTP版本不受支持';
                    break
                default:
                    error.message = '服务暂不可用，请稍后重试';
                    break
            }
            handleError(error)
            throw error
        }
    )
    return service
}

function stringify(data) {
    return qs.stringify(data, { allowDots: true, encode: false })
}

/**
 * @description 创建请求方法
 * @param {Object} service axios 实例
 */
function createRequest(service, data) {
    return function (config) {
        // console.log(process.env.VUE_APP_SERVER_API)
        const token = cookies.get('token')
        const configDefault = {
            headers: {
                Authorization: token,
                'Content-Type': get(config, 'headers.Content-Type', 'application/json'),
                rpcType: 'dubbo'
            },
            timeout: 20000,
            baseURL: process.env.VUE_APP_SERVER_API,
            data: data
        }
        const option = merge(configDefault, config)
        // console.log(option)
        // 处理 get 请求的参数
        // 请根据实际需要修改
        if (!isEmpty(option.params)) {
            option.url = option.url + '?' + stringify(option.params)
            option.params = {}
        }
        // console.log(option)
        // 当需要以 form 形式发送时 处理发送的数据
        // 请根据实际需要修改
        if (!isEmpty(option.data) && option.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
            option.data = stringify(option.data)
        }
        return service(option)
    }
}

// 用于真实网络请求的实例和请求方法
export const service = createService()
export const request = createRequest(service)